// extracted by mini-css-extract-plugin
module.exports = {"root":"jlU0G74tpKAZXM80EZCg"};